"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../../helpers");
exports.StyledContainer = components_core_1.styled.div `
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  min-height: 530px;

  @media (min-width: ${helpers_1.Breakpoints.b960}px) {
    height: calc(100vh - 200px);
  }
`;
